import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useSignIn } from '@/Recoil/Session/Session';

interface MainScreenProps {
    onMateSignin: () => void;
    onEmailSignin: () => void;
    onSuccess: () => void;
}

const MainScreen: React.FC<MainScreenProps> = ({ onMateSignin, onEmailSignin, onSuccess }) => {
    const { googleSignIn } = useSignIn();
    const [isLoading, setIsLoading] = useState(false);

    const handleGoogleLogin = useGoogleLogin({
        flow: 'auth-code',
        onSuccess: async (response) => {
            setIsLoading(true);
            try {
                const result = await googleSignIn(response.code);
                if (result) {
                    onSuccess();
                }
            } finally {
                setIsLoading(false);
            }
        },
        onError: (error) => {
            console.error('Google login error:', error);
            setIsLoading(false);
        }
    });

    return (
        <div className="main-signin">
            <div className="login-header">
                <h1>{"Welcome to MATE"}</h1>
            </div>

            <button
                type="button"
                className="google-signin-button"
                onClick={() => handleGoogleLogin()}
                disabled={isLoading}
            >
                <svg width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                {isLoading ? "Signing in..." : "Sign in with Google"}
            </button>

            <button
                type="button"
                className="mate-signin-button"
                onClick={onMateSignin}
            >
                {"Sign in with MATE"}
                <div className="mate-icons">
                    <svg className="ios-icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                    </svg>
                    <svg className="android-icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M17.523 15.3414c-.5511 0-.9993-.4486-.9993-.9997s.4482-.9993.9993-.9993c.5511 0 .9993.4483.9993.9993.0001.5511-.4482.9997-.9993.9997m-11.046 0c-.5511 0-.9993-.4486-.9993-.9997s.4482-.9993.9993-.9993c.5511 0 .9993.4483.9993.9993 0 .5511-.4482.9997-.9993.9997m11.4045-6.02l1.9973-3.4592a.416.416 0 00-.1518-.5972.416.416 0 00-.5972.1518l-2.0223 3.5046C15.5889 8.2231 13.8956 7.8098 12.0034 7.8098c-1.8922 0-3.5855.4133-5.2077 1.0648L4.7734 5.4592a.4161.4161 0 00-.5972-.1518.416.416 0 00-.1518.5972l1.9973 3.4592C2.6889 11.1867.3432 14.6589 0 18.761h24c-.3432-4.1021-2.6889-7.5743-6.1185-9.4796"/>
                    </svg>
                </div>
            </button>

            <div className="download-app-section">
                <div className="divider">
                    <span>{"Don't have the app?"}</span>
                </div>
                <div className={`qr-code-container`}>
                    <a href="https://koreanmate.onelink.me/Tkco/y94asact" target="_blank" rel="noopener noreferrer">
                        <img
                            src="https://static.koreanmate.app/download_app.png"
                            alt="Download MATE App QR Code"
                            className="download-qr-code"
                        />
                    </a>
                    <p className="qr-text">{"Scan or click to download MATE app"}</p>
                </div>
            </div>
        </div>
    );
};

export default MainScreen;